<template lang="pug">
.insights-proficiency-badge(:class="badgeClasses")
  | {{ finalScore }}
</template>

<script>
import { isNil } from 'lodash-es';
import { proficiencyClasses } from '~/utils/insights_utils';
import { INSIGHTS } from '~/app_constants';

export default {
  name: 'InsightsProficiencyBadge',
  props: {
    score: {
      required: true,
      validator: (value) => typeof value === 'number' || isNil(value),
    },
    size: {
      type: String,
      default: 'default',
    },
  },
  computed: {
    hasScore() {
      return this.score !== null && typeof this.score !== 'undefined';
    },
    finalScore() {
      return this.hasScore ? Math.round(this.score) : INSIGHTS.empty_states.no_data.no_data_symbol;
    },
    badgeClasses() {
      return [proficiencyClasses(this.score, 'insights-proficiency-badge'), `insights-proficiency-badge-${this.size}`];
    },
  },
};
</script>
